import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { Identifier } from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
export const generateSchedule = (organized_values: any, notify: any, redirectTo: any) => {
  axios
    .post(`/api/v1/console/schedules/generate/`, organized_values)
    .then((response) => {
      notify('Generating schedule. Schedule is finished when Status changes from PENDING to READY.', {
        type: 'info',
      })
      redirectTo(`/schedules/${response['data']['schedule']}/show`)
    })
    .catch((error) => {
      notify(`${error.message}. ${error.response?.data}`, { type: 'warning' })
      captureExceptionIfProduction(error)
    })
}

export const prefillLocations = (start_date: any, end_date: any, user: any) => {
  return axios
    .get(`/api/v1/console/schedules/prefill-locations/`, {
      params: {
        start_date,
        end_date,
        user,
      },
    })
    .catch((error) => {
      console.error(`${error.message}. ${error.response?.data}`)
      captureExceptionIfProduction(error)
    })
}

export const hosPlan = (schedule: any) => {
  return axios.get(`/api/v1/console/schedules/${schedule.id}/hos-plan/`).catch((error) => {
    console.error(`${error.message}. ${error.response?.data}`)
    captureExceptionIfProduction(error)
  })
}

export const startFeasibilityCheck = (kind: string, id: Identifier) => {
  return axios
    .post(`/api/v1/console/feasibility-stat/start/`, {
      kind,
      id,
    })
    .then((response) => {
      if (response.status === HttpStatus.OK) {
        return response.data
      }
    })
    .catch((error) => {
      captureExceptionIfProduction(error)
    })
}
